import { ActionCreator } from 'redux';
import { CampaignSimpleStats } from '@dev/ee-api/ee-api-models';

import { CampaignsActionTypes } from '@/store/campaigns/types';
import { GetCampaignSimpleStatsAllDataSuccessAction } from './types';

export const GetCampaignSimpleStatsAllDataSuccess: ActionCreator<GetCampaignSimpleStatsAllDataSuccessAction> = (
    pickedCampaignSimpleStatsAllData: CampaignSimpleStats
): GetCampaignSimpleStatsAllDataSuccessAction => ({
    type: CampaignsActionTypes.GET_CAMPAIGN_SIMPLE_STATS_ALL_DATA_SUCCESS,
    payload: pickedCampaignSimpleStatsAllData,
});
